// extracted by mini-css-extract-plugin
export default {"themeColor":"#58b6fe","themeColor2":"#d8d8d8","themeColor3":"#fff"};